import { render, staticRenderFns } from "./UserSet.vue?vue&type=template&id=00023ecc&scoped=true&"
import script from "./UserSet.vue?vue&type=script&lang=js&"
export * from "./UserSet.vue?vue&type=script&lang=js&"
import style0 from "./UserSet.vue?vue&type=style&index=0&id=00023ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00023ecc",
  null
  
)

export default component.exports